import React from 'react';
import PropTypes from 'prop-types';
import {View} from 'react-native';
import {Divider} from 'react-native-paper';

import sy from '~/styles';
import {Text} from '~/components/controls';

const RobServiceHistory = ({activities}) => {
  const sortedActivities = [...(activities ?? [])].sort((a, b) => {
    if (!a.robCode && b.robCode) {
      return 1;
    }
    if (!b.robCode && a.robCode) {
      return -1;
    }
    if (a.robCode && b.robCode) {
      return a.robCode.localeCompare(b.robCode);
    }
    return (a.description ?? '').localeCompare(b.description ?? '');
  });

  return sortedActivities.map((item, index, arr) => (
    <React.Fragment key={`${item.robCode ?? 'unknown'}-${index}`}>
      <View style={[sy['p-4'], sy['flex-row'], sy['gap-5']]}>
        <Text>{item.robCode}</Text>
        <View style={[sy['flex-1']]}>
          <Text>{item.description}</Text>
          <Text style={[sy.smallRegular, sy['text-lightgray']]}>
            {item.operation?.description}
          </Text>
        </View>
      </View>
      {index < arr.length - 1 && <Divider style={sy['bg-gray95']} />}
    </React.Fragment>
  ));
};

RobServiceHistory.propTypes = {
  activities: PropTypes.arrayOf(
    PropTypes.shape({
      robCode: PropTypes.string,
      description: PropTypes.string,
      operation: PropTypes.shape({
        description: PropTypes.string,
      }),
    }),
  ),
};

export default RobServiceHistory;
